'use client';
import * as React from 'react';

import { colors } from '../color-v2';

const NextTopLoader = () => {
  const defaultColor = colors.palette.PRIMARY_500;
  const defaultHeight = 3;

  // Any falsy (except undefined) will disable the shadow
  const boxShadow = `box-shadow:0 0 10px ${defaultColor},0 0 5px ${defaultColor}`;

  // Check if to show at bottom
  const positionStyle = 'top: 0;';
  const spinnerPositionStyle = 'top: 15px;';

  /**
   * CSS Styles for the NextTopLoader
   */
  const styles = (
    <style>
      {`#nprogress{pointer-events:none}#nprogress .bar{background:${defaultColor};position:fixed;z-index:1600;${positionStyle}left:0;width:100%;height:${defaultHeight}px}#nprogress .peg{display:block;position:absolute;right:0;width:100px;height:100%;${boxShadow};opacity:1;-webkit-transform:rotate(3deg) translate(0px,-4px);-ms-transform:rotate(3deg) translate(0px,-4px);transform:rotate(3deg) translate(0px,-4px)}#nprogress .spinner{display:block;position:fixed;z-index:1600;${spinnerPositionStyle}right:15px}#nprogress .spinner-icon{width:18px;height:18px;box-sizing:border-box;border:2px solid transparent;border-top-color:${defaultColor};border-left-color:${defaultColor};border-radius:50%;-webkit-animation:nprogress-spinner 400ms linear infinite;animation:nprogress-spinner 400ms linear infinite}.nprogress-custom-parent{overflow:hidden;position:relative}.nprogress-custom-parent #nprogress .bar,.nprogress-custom-parent #nprogress .spinner{position:absolute}@-webkit-keyframes nprogress-spinner{0%{-webkit-transform:rotate(0deg)}100%{-webkit-transform:rotate(360deg)}}@keyframes nprogress-spinner{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}`}
    </style>
  );

  return styles;
};
export default NextTopLoader;
